import ImageArrow from "components/utility/images/ImageArrow";
import StickyHeader from "components/utility/sticky-header/StickyHeader";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";

const ClientHomeTabLoader = () => {
	return (
		<StickyHeaderContainer>
			<StickyHeader>
				<section className="home-browseby-bar container placeholder">
					<div className="grid-12 home-browseby-bar-desktop">
						<div className="home-browseby-bar-left">
							<div className="home-browseby-bar-title">
								<p className="label-1-left-medium-cool-gray">Browse By</p>
							</div>
							<div className="home-browseby-options-container">
								<div className="home-browseby-options-list ">
									<h2 className="t-heading-lg home-browseby-options-list-name">Topic</h2>
								</div>
								<div className="home-browseby-options-list ">
									<h2 className="t-heading-lg home-browseby-options-list-name">Format</h2>
								</div>
								<div className="home-browseby-options-list ">
									<h2 className="t-heading-lg home-browseby-options-list-name">Use</h2>
								</div>
							</div>
						</div>
						<div className="home-browseby-bar-right">
							<div className="home-browseby-bar-sort-container">
								<div className="coveo-headless-sort ">
									<span className="coveo-headless-sort-value t-label-xs-heavy tc-cool-gray-02">
										sort by: Newest
									</span>
									<svg
										className="image-arrow"
										xmlns="http://www.w3.org/2000/svg"
										xmlnsXlink="http://www.w3.org/1999/xlink"
										width="24"
										height="24"
										viewBox="0 0 24 24"
									>
										<polygon
											className="image-fill-color"
											points="5.074013 7.98131329 11.5463467 14.452899 18.074013 7.925987 18.074013 10.547101 11.5463467 17.074013 5.074013 10.6024273"
										></polygon>
									</svg>
								</div>
							</div>
						</div>
						<div className={`home-browseby-options-sublist`}></div>
					</div>
					<div className="home-browseby-bar-mobile">
						<div className="home-browseby-bar-mobile-title">
							<h3 className="h3-center-medium-cool-medium-cool-gray">Browse and Explore</h3>
						</div>
						<div className="home-browseby-bar-mobile-filters">
							<div className="home-browseby-bar-mobile-filter-button">
								<div className="home-browseby-bar-mobile-browseby">
									<div>Browse By</div>
									<div className={`home-browseby-bar-mobile-filter-count`}>{null}</div>
								</div>
							</div>
							<div className="home-browseby-bar-mobile-filter-button">
								<div className="home-browseby-bar-mobile-sortby">
									<div className="home-browseby-bar-mobile-sortby-label">NEWEST</div>
									<ImageArrow />
								</div>
							</div>
						</div>
					</div>
				</section>
			</StickyHeader>
		</StickyHeaderContainer>
	);
};
export default ClientHomeTabLoader;
